import { Injectable } from '@angular/core';
import { MedicalConditionModel } from '../../../models/master-data/medical-condition.model';
import { BaseService } from '../../../shared/services/base.service';
import { MedicalConditionCategoryUrl } from '../../../shared/urls/master-data.medical-condition-category.urls';
import { MedicalConditionUrl } from '../../../shared/urls/master-data.medical-condition.urls';
@Injectable()
export class MedicalConditionService {
    constructor(public baseService: BaseService) {
    }

    addNewMedical(param) {
        return this.baseService.postData(MedicalConditionUrl.MEDICALCONDITION_ADD, param);
    }

    updateMedical(id, param) {
        const url = MedicalConditionUrl.MEDICALCONDITION_UPDATE.replace('{id}', id);
        return this.baseService.update(url, param);
    }

    deleteMedical(id) {
        const url = MedicalConditionUrl.MEDICALCONDITION_DELETE.replace('{id}', id);
        return this.baseService.delete(url);
    }

    getMedicalCategory(){
        return this.baseService.getData(MedicalConditionCategoryUrl.MEDICALCONDITIONCATEGORY_DROP_DOWN_LIST);
    }

    getMedicalConditionList(param) {
        return this.baseService.getData(MedicalConditionUrl.MEDICALCONDITION_SEARCH, param);
    }

    getMedicalCondition(id) {
        const url = MedicalConditionUrl.MEDICALCONDITION_GET.replace('{id}', id);
        return this.baseService.getData(url);
    }
}



// WEBPACK FOOTER //
// D:/TMB/sr-git-v1/TMB.UI/src/app/pages/master-data/medical-condition/medical-condition.service.ts